import React from "react";
import Helmet from "react-helmet";
import { Link } from "gatsby";
import config from "../../data/SiteConfig";
import Layout from "./../layout/index";
import Home from "../components/home/home";
import "../../static/FuturaPT/stylesheet.css";

console.log("config ", config);

const Index = props => {
  return (
    <Layout location={props.location}>
      <Helmet title={`Home | ${config.siteTitle}`} />
      <Home />
    </Layout>
  );
};

export default Index;
